import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ForgotPwdCard } from '../../components';
import { LoginNotiOneStyle, LoginNotiTwoStyle, loginrightBg02, LoginNotiThirdStyle, LoginNotiFourStyle } from '../../img'; // logown, backIcon, loginUserBg
// NotiflyLogo,
import { forgetPD } from '../../ducks/auth';
import { Link } from 'react-router';
import SimpleReactValidator from 'simple-react-validator';

class ForgotPwd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      e: ''
    };
    this.validator = new SimpleReactValidator();
  }

  handleStateChange = (state, value) => {
    this.setState({ [state]: value });
  }

  componentDidMount = () => {
    let mainDiv = document.getElementById('main-wrapper');
    mainDiv.className = 'pb-0 mob-log';
  }

  handlerForgetPD = (e) => {
    if (window.mixpanel) {
      window.mixpanel.track('forgetpass_click', {
        '$email': ''
      });
    }

    e.preventDefault();
    let that = this;

    if (!that.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      this.props.forgetPD(this.state);
    }
  }

  render() {
    return (
      <div>
        <div className="nf_login-area nf_forgetpw-area">
          <header className="header-app-login header-containet-login">
            <div className="">
              <Link className="logo-text" to={`${process.env.REACT_APP_ROUTE_PREFIX}`}> Widgetshub</Link>
              {/* <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon" src={IconLogo} alt="notifly" /></Link>
            <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist?ds=list`}><img className="logo-icon-text" src={IconLogoText} alt="notifly" /></Link> */}
            </div>
          </header>
          <div className="wdg_container-login100">
            <div className="wdg_login-col-form  nf_login-box" >
              <div className=" wdg-login-part">
                <div className="wdg-login-header mb-30">
                  <h1 className="display-1  brand-color">
                    Forgot Password ?
                  </h1>
                  <h4 className="text-left font-normal">
                    Don't worry sit back  and fell relax we will take care of this
                  </h4>
                  {/* <div className="nf-frg-back">
                    <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}login`}> <img src={backIcon} alt="arrow" /></Link>
                  </div> */}
                </div>
                <div className="nf_login-block">
                  <div className="login-title">
                    <h3 className="display-3 text-left">Reset your password</h3>
                  </div>
                  <ForgotPwdCard
                    handleStateChange={this.handleStateChange}
                    handlerForgetPD={this.handlerForgetPD}
                    validator={this.validator}
                    state={this.state}
                    loading={this.props.loading}
                  />
                  <h5>Do you know password ? <Link className="text-primary" to={`${process.env.REACT_APP_ROUTE_PREFIX}login`}>Login Now</Link> </h5>
                </div>
              </div>
            </div>
            <div className="wdg_login-col-banner  nf_login-box" >
              <div className="login-side-text">
                <h2 className="signup-noti-text" style={{marginBottom:'40px'}}>
                  {/* When people hear about your brand from real people, they trust your brand and also establishes your brand as a prominent one. */} Social Wall For Embed Or Display <br />
                Widgetshub allows the integration of different content, especially from most social platforms.
                </h2>
              </div>
              <div className="login-display-noti" style={{ display: 'none' }}>
                <img className="notifiavtion-one" src={LoginNotiOneStyle} alt="" id='forget-1' style={{ display: 'none' }} />
                <img src={LoginNotiTwoStyle} alt="" id='forget-2' style={{ display: 'none' }} />
                <img src={LoginNotiThirdStyle} alt="" id='forget-3' style={{ display: 'none' }} />
                <img src={LoginNotiFourStyle} alt="" id="forget-4" style={{ display: 'none' }} />
              </div>
              <div className="loginusercomputer">
                <img className="signup-right-img" src={loginrightBg02} alt="" />
              </div>

              {/* <a href='https://wisernotify.com/' className="login-logo">
                <img src={logown} alt="" />
              </a> */}
            </div>
          </div>
        </div>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  login: state.forget,
  loading: state.getIn(['loading', 'state']),
});

const mapDispatchToProps = {
  forgetPD
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ForgotPwd);



// WEBPACK FOOTER //
// ./src/containers/ForgotPwd/ForgotPwd.js